import { createApp } from "vue";
import { createPinia } from "pinia";
import { createRouter, createWebHashHistory } from "vue-router";
import App from "./App.vue";
import "./assets/main.css";

// Import views
import Home from "./views/Home.vue";
import Products from "./views/Products.vue";
import ProductDetail from "./views/ProductDetail.vue";
import Checkout from "./views/Checkout.vue";
import Login from "./views/Login.vue";

// Create router
const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    { path: "/", component: Home },
    { path: "/products", component: Products },
    { path: "/product/:id", component: ProductDetail },
    { path: "/checkout", component: Checkout },
    { path: "/login", component: Login },
  ],
});

// Create Pinia store
const pinia = createPinia();

// Create and mount app
const app = createApp(App);
app.use(router);
app.use(pinia);

// Initialize auth store
import { useAuthStore } from "./stores/auth";
const authStore = useAuthStore();
authStore.initializeAuth();

app.mount("#app");
